module.exports = __webpack_public_path__ + "static/media/Wolf.8c1ff3a7.png";